import { createTheme } from "@mui/material/styles";

// Single UI font: Inter, with REAL weight files (400/500/600/700) loaded in
// public/index.html. Both constants point at the same stack — they are kept
// as separate exports because components import them by role.
//
// (Previously FONT_BODY was "Puvi" via an @font-face whose CDN URL 404'd and
// whose single file was declared for weights 100-900 — bold text rendered as
// blurry faux-bold. See src/App.css for the full note.)
export const FONT_HEADING = '"Inter", system-ui, sans-serif';
export const FONT_BODY = '"Inter", system-ui, sans-serif';

const theme = createTheme({
  typography: {
    fontFamily: FONT_BODY,
    h1: { fontFamily: FONT_HEADING },
    h2: { fontFamily: FONT_HEADING },
    h3: { fontFamily: FONT_HEADING },
    h4: { fontFamily: FONT_HEADING },
    h5: { fontFamily: FONT_HEADING },
    h6: { fontFamily: FONT_HEADING },
    button: { fontFamily: FONT_BODY, textTransform: "none" },
  },
});

export default theme;
